// @flow
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import rootReducer from './reducers';
import { initialize, addTranslationForLanguage } from 'react-localize-redux';
import { defaultLang } from './brand-configs';
const dataLayer = window.dataLayer;
export const history = createHistory();

history.listen((location) => {
  dataLayer.push({ page: `${location.pathname}${location.search}` });
  dataLayer.push({ event: 'pageChange' });
});

const initialState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(rootReducer, initialState, composedEnhancers);

const languages = ['en', 'jp'];
const missingTranslationMsg = 'Missed translation: ${key} for languge ${code}!';

store.dispatch(initialize(languages, { defaultLanguage: defaultLang, missingTranslationMsg }));
store.dispatch(addTranslationForLanguage(require('./langs/en.json'), 'en'));
store.dispatch(addTranslationForLanguage(require('./langs/jp.json'), 'jp'));

export default store;



// WEBPACK FOOTER //
// ./src/store.js